import { useMemo } from 'react';

import { useAppState } from '../AppStateProvider';
import UrlService from '../services/UrlService';

export const useIsWithinCrm = () => {
  const { url } = useAppState();

  if (!url) {
    return false;
  }

  const isWithinCrm = useMemo(() => {
    const parsedUrl = new URL(url);
    const isWithinSalesloft = UrlService.isSalesloftUrl(parsedUrl);
    const isWithinHubspot = UrlService.isHubspotUrl(parsedUrl);
    const isWithinSalesforce = UrlService.isSalesforceUrl(parsedUrl) || UrlService.isSalesforceLightningUrl(parsedUrl);
    const isMicrosoftDynamics = UrlService.isMicrosoftDynamicsUrl(parsedUrl);
    return isWithinHubspot || isWithinSalesforce || isMicrosoftDynamics || isWithinSalesloft;
  }, [url]);

  return isWithinCrm;
};
